import React from 'react';
import { Camera } from 'lucide-react';
export function PhotoGallery() {
  const photos = [{
    url: 'https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=600',
    caption: 'Community Gathering'
  }, {
    url: 'https://images.unsplash.com/photo-1511632765486-a01980e01a18?w=600',
    caption: 'Family Events'
  }, {
    url: 'https://images.unsplash.com/photo-1559027615-cd4628902d4a?w=600',
    caption: 'Local Volunteers'
  }, {
    url: 'https://images.unsplash.com/photo-1517457373958-b7bdd4587205?w=600',
    caption: 'Neighborhood Festivals'
  }, {
    url: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=600',
    caption: 'Sylmar Parks & Nature'
  }, {
    url: 'https://images.unsplash.com/photo-1544928147-79a2dbc1f389?w=600',
    caption: 'Community Pride'
  }];
  return <section className="py-24 px-6 lg:px-8 bg-charcoal text-white" data-id="element-386">
      <div className="max-w-7xl mx-auto" data-id="element-387">
        <div className="text-center mb-16" data-id="element-388">
          <Camera className="w-10 h-10 text-warm mx-auto mb-4" data-id="element-389" />
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-2" data-id="element-390">
            Nuestra Comunidad en Acción
          </h2>
          <p className="text-xl text-sky font-medium" data-id="element-391">
            Our Community in Action
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-392">
          {photos.map((photo, index) => <div key={index} className="relative group overflow-hidden rounded-xl aspect-video bg-charcoal-dark cursor-pointer" data-id="element-393">
              <img src={photo.url} alt={photo.caption} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-394" />
              <div className="absolute inset-0 bg-gradient-to-t from-charcoal-dark/90 via-charcoal-dark/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-6" data-id="element-395">
                <p className="text-white font-bold text-lg translate-y-4 group-hover:translate-y-0 transition-transform duration-300" data-id="element-396">
                  {photo.caption}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}